// components/map/MapStateTracker.jsx
import { useMap } from 'react-leaflet';
import { useRef, useEffect, useCallback } from 'react';

function MapStateTracker({ mapCenter, mapZoom, setMapCenter, setMapZoom }) {
  const map = useMap();
  const debounceTimeout = useRef(null);

  const debouncedMoveEndHandler = useCallback(() => {
    clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      const currentCenter = [map.getCenter().lat, map.getCenter().lng];
      const currentZoom = map.getZoom();
      const COORD_TOLERANCE = 0.00001;

      const centerChanged =
        !mapCenter ||
        Math.abs(mapCenter[0] - currentCenter[0]) > COORD_TOLERANCE ||
        Math.abs(mapCenter[1] - currentCenter[1]) > COORD_TOLERANCE;

      const zoomChanged = mapZoom !== currentZoom;

      if (centerChanged) setMapCenter(currentCenter);
      if (zoomChanged) setMapZoom(currentZoom);
    }, 200);
  }, [map, mapCenter, mapZoom, setMapCenter, setMapZoom]);

  useEffect(() => {
    map.on('moveend', debouncedMoveEndHandler);
    return () => {
      map.off('moveend', debouncedMoveEndHandler);
      clearTimeout(debounceTimeout.current);
    };
  }, [map, debouncedMoveEndHandler]);

  return null;
}

export default MapStateTracker;